import { useState, useRef } from 'react';
import HighchartsReact from 'highcharts-react-official'
import Highcharts from "highcharts";
import { AnimatePresence, motion } from 'framer-motion';
import DataNotFound from '../loader/data-not-found';
import InnerLoader from '../loader/inner-loader';
import Accessibility from "highcharts/modules/accessibility";

// CRA / Webpack-safe version
if (typeof Accessibility === "function") {
    Accessibility(Highcharts);
} else if (Accessibility?.default) {
    Accessibility.default(Highcharts);
}

export const CustomHighChart = ({ isLoad = false, options = {}, titleNotFound = "Data Chart", condition = true }) => {
    const [allSeriesHidden, setAllSeriesHidden] = useState(false);
    const chartRef = useRef(null);

    const hasChartData = (opt) => {
        if (!opt?.series) return false;

        const seriesArr = Array.isArray(opt.series) ? opt.series : [opt.series];

        return seriesArr.some((s) =>
            Array.isArray(s?.data) &&
            s.data.length > 0 &&
            s.data.some((point) =>
                (typeof point === "number" && point > 0) ||
                (typeof point === "object" && point !== null && Number(point.y) > 0)
            )
        );
    };

    const handleLegendToggle = function () {
        const chart = this.chart;
        setTimeout(() => {
            const allHidden = chart.series.every((s) => !s.visible);
            setAllSeriesHidden(allHidden);
        }, 0);
    };

    const handleReset = () => {
        const chart = chartRef.current?.chart;

        chart?.series.forEach(series => {
            if (series.type === 'pie') {
                series.points.forEach(p => p.setVisible(true, false));
            } else {
                series.show(false);
            }
        });

        chart?.redraw();
        setAllSeriesHidden(false);
    };

    const hasVisibleData = (chart) => {
        if (!chart) return false;

        return chart.series.some(series => {
            // Pie / Donut
            if (series.type === 'pie') {
                return series.points?.some(p => p.visible && p.y > 0);
            }

            // Line / Bar / Area / Column
            return (
                series.visible &&
                series.data?.some(p => p.y > 0)
            );
        });
    };

    const enhancedOptions = {
        ...options,
        accessibility: { enabled: false },
        plotOptions: {
            ...options.plotOptions,
            series: {
                ...options.plotOptions?.series,
                events: {
                    legendItemClick: function () {
                        const chart = this.chart;
                        setTimeout(() => {
                            setAllSeriesHidden(!hasVisibleData(chart));
                        }, 0);
                    }
                }
            },
            pie: {
                ...(options.plotOptions?.pie || {}),
                point: {
                    events: {
                        legendItemClick: function () {
                            const chart = this.series.chart;
                            setTimeout(() => {
                                setAllSeriesHidden(!hasVisibleData(chart));
                            }, 0);
                        }
                    }
                }
            }
        }
    };

    const showChart = condition && hasChartData(options);

    return (
        isLoad ? (
            <div className="w-full h-full relative">
                {showChart && <HighchartsReact ref={chartRef} highcharts={Highcharts} options={enhancedOptions} />}

                <AnimatePresence>
                    {allSeriesHidden && (
                        <motion.div
                            className="absolute inset-0 flex flex-col items-center justify-center bg-white bg-opacity-80 max-h-[250px] xl:max-h-[300px]"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.3 }}
                        >
                            <DataNotFound content={<span>All Series Hidden</span>} />

                            <motion.button
                                className="mt-4 px-5 py-2 bg-blue-600 text-white rounded shadow-lg"
                                whileHover={{ scale: 1.05, backgroundColor: '#2563eb', boxShadow: '0px 5px 15px rgba(0,0,0,0.3)' }}
                                whileTap={{ scale: 0.95 }}
                                onClick={handleReset}
                                transition={{ type: 'spring', stiffness: 300, damping: 20 }}
                            >
                                Show All Series
                            </motion.button>
                        </motion.div>
                    )}
                </AnimatePresence>

                {!showChart && !allSeriesHidden && (
                    <div className="w-full h-full  flex items-center justify-center">
                        <DataNotFound title={titleNotFound} />
                    </div>
                )}
            </div>
        ) : (
            <InnerLoader />
        )
    );
}




// import HighchartsReact from 'highcharts-react-official'
// import Highcharts from "highcharts";
// import DataNotFound from '../loader/data-not-found';
// import InnerLoader from '../loader/inner-loader';
// import { useState } from 'react';

// const hasChartData = (opt) =>
//     Array.isArray(opt?.series) &&
//     opt.series.some((s) => {
//         if (!Array.isArray(s?.data)) return false;

//         return s.data.some((point) => {
//             if (typeof point === 'number') return point > 0;
//             if (typeof point === 'object' && point !== null)
//                 return Number(point.y) > 0;
//             return false;
//         });
//     });

// export const CustomHighChart = ({ isLoad = false, options = {}, titleNotFound = "Data Chart", condition = true }) => {
//     // const hasChartData = (opt) => Array.isArray(opt?.series) && opt.series.some((s) => Array.isArray(s?.data) && s.data.length > 0);
//     const [allSeriesHidden, setAllSeriesHidden] = useState(false);

//     const handleLegendToggle = function () {
//         const chart = this.chart;
//         setTimeout(() => {
//             const allHidden = chart.series.every((s) => !s.visible);
//             setAllSeriesHidden(allHidden);
//         }, 0);
//     };

//     const enhancedOptions = {
//         ...options,
//         plotOptions: {
//             ...options.plotOptions,
//             series: {
//                 ...options.plotOptions?.series,
//                 events: {
//                     legendItemClick: handleLegendToggle,
//                 },
//             },
//         },
//     };

//     const showChart = hasChartData(enhancedOptions) && condition && !enhancedOptions.series.every(s => !s.visible);

//     console.log('Chart series:', enhancedOptions.series);
//     console.log('Has data:', hasChartData(enhancedOptions));

//     return (
//         isLoad ? (
//             showChart ? (
//                 <HighchartsReact highcharts={Highcharts} options={enhancedOptions} />
//             ) : (
//                 <div className="w-full h-full flex items-center justify-center">
//                     <DataNotFound title={titleNotFound} />
//                 </div>
//             )
//         ) : (
//             <InnerLoader />
//         )
//     )
// }
